/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_Tab_SubInputs */

const vi_shop_home_hero_tab_sub = /** @type {(inputs: Shop_Home_Hero_Tab_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng phụ của tab`)
};

/**

* @param {Shop_Home_Hero_Tab_SubInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_tab_sub = /** @type {((inputs?: Shop_Home_Hero_Tab_SubInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_Tab_SubInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_tab_sub(inputs)
});